import { Injectable } from '@angular/core';
import { WebhookListItem } from 'app/webhooks/model/webhooks.model';
import { GetAllWebhooksAction } from 'app/webhooks/webhooks.actions';
import { getWebhookFilteredListSelector } from '../webhooks.reducer';
import { Observable } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Store } from '@ngrx/store';
import { IState } from 'app/shared/models/state';

@Injectable()
export class WebhookListData extends DataSource<WebhookListItem> {
  constructor(private store: Store<IState>) {
    super();
  }

  init() {
    this.store.dispatch(new GetAllWebhooksAction());
  }

  connect(): Observable<WebhookListItem[]> {
    return this.store.select(getWebhookFilteredListSelector);
  }

  disconnect(collectionViewer: CollectionViewer): void {}
}
